import gql from 'graphql-tag'
import * as React from 'react'
import { QueryProps, graphql } from 'react-apollo'
import { CountryType } from '../../Shared/CountryOptions'
import {
  Contact,
  ContactList,
  ContactListWrapper,
  EmText,
  MailTo,
  TinyText,
  TitleList
} from './contactStyles'

const PlaceholderImage = require('../../Results/Contacts/placeholder.png')

export const CONTACT_QUERY = gql`
  query ContactsQuery($contactSearch: ContactSearch) {
    contacts(contactSearch: $contactSearch) {
      id
      title
      contacts {
        name
        email
        telephone
        mobile
        imageUrl
      }
    }
  }
`

export type Contact = {
  name: string
  telephone?: string
  mobile?: string
  email: string
  imageUrl?: string
}

export type ContactList = {
  id: string
  title: string
  contacts: Contact[]
}

type Response = {
  countries: CountryType[]
  contacts: ContactList[]
}

type InputProps = {
  country?: string
}

type ApolloProps = Response & QueryProps
type WrappedProps = ApolloProps & InputProps

class ListContacts extends React.Component<WrappedProps> {
  render() {
    const { loading, error, contacts } = this.props

    if (loading) {
      return <div>Loading</div>
    }

    if (error) {
      return <h1>ERROR</h1>
    }

    return (
      <ContactListWrapper>
        {contacts.map((contactTitle, titleIndx) => (
          <TitleList key={titleIndx}>
            <h4>{contactTitle.title}</h4>
            <br />
            <ContactList>
              {contactTitle.contacts.map((contact, indx) => (
                <Contact key={indx}>
                  <div>
                    <img
                      src={
                        contact.imageUrl ? contact.imageUrl : PlaceholderImage
                      }
                    />
                  </div>
                  <address>
                    <EmText>{contact.name}</EmText>
                    {contact.telephone && (
                      <TinyText>Tel. {contact.telephone}</TinyText>
                    )}
                    {contact.mobile && (
                      <TinyText>Mob. {contact.mobile}</TinyText>
                    )}
                    <TinyText>
                      <MailTo href={`mailto:${contact.email}`}>
                        {contact.email}
                      </MailTo>
                    </TinyText>
                  </address>
                </Contact>
              ))}
            </ContactList>
          </TitleList>
        ))}
      </ContactListWrapper>
    )
  }
}

export const withContacts = graphql<Response, InputProps, ApolloProps>(
  CONTACT_QUERY,
  {
    options: props => ({
      variables: { contactSearch: { country: props.country } },
      fetchPolicy: 'network-only'
    }),
    props: ({ data }) => ({ ...data })
  }
)

export default withContacts(ListContacts)



// WEBPACK FOOTER //
// ./src/Components/Layout/Features/ListContacts.tsx